import { EStepCode } from '../../../types/form';
import { EDealTypeEx } from '../../../repositories/demand/entities/public_v5_create_message/RequestMessageV5Schema';

export enum EOfferType {
  Flat = 'flat',
  Suburban = 'suburban',
  Commercial = 'commercial',
}

const objectToSkipStepMap: Record<EOfferType, EStepCode[]> = {
  [EOfferType.Flat]: [EStepCode.ObjectTypeFlat],
  [EOfferType.Suburban]: [EStepCode.ObjectTypeSuburban, EStepCode.ObjectTypeSuburbanWithLand],
  [EOfferType.Commercial]: [EStepCode.ObjectTypeCommercial, EStepCode.ObjectTypeCommercialWithBusiness],
};

// oxlint-disable-next-line typescript/no-explicit-any
export const generateSkipSteps = (formData: Record<string, any>): EStepCode[] => {
  const { dealTypeEx: dealType, offerType, objectType } = formData;

  const result = [
    dealType && EStepCode.DealTypeEx,
    offerType && EStepCode.OfferType,
    objectType && offerType && objectToSkipStepMap[offerType as EOfferType],
    dealType && [EDealTypeEx.Tenant, EDealTypeEx.Rent].includes(dealType) && EStepCode.RentType,
  ];

  return [].concat(...result).filter(Boolean) as EStepCode[];
};
